<template>
  <div>
    <Head>
      <link
        rel="canonical"
        :href="$page.props.canonical_url"
        inertia
      >
      <title>{{ seoTitle }}</title>
      <meta
        name="title"
        :content="seoTitle"
      >
      <meta
        name="description"
        :content="seoDescription"
      >
      <meta
        name="keywords"
        :content="seoKeywords"
      >
    </Head>

    <div class="flex justify-center items-center h-screen">
      <div class="flex flex-col justify-items-center">
        <FlashingLight class="my-10" />

        <div class="rounded-lg max-w-4xl !mx-2 sm:mx-auto">
          <TwitchAuction
            v-if="auction"
            :enable-autobid="false"
            :item="auction"
            @almostEnding="auctionAlmostEnding"
            @isEnding="auctionIsEnding"
            @hasWon="auctionHasWon"
            @ended="auctionEnded"
          />
          <div v-else>
            Er zijn nog geen veilingen, even geduld!<br>
            <a
              v-if="streamUrl"
              :href="streamUrl"
              class="mt-2 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-purple-500 hover:bg-purple-600 text-base font-medium text-white sm:col-start-2 sm:text-sm w-full"
              target="_blank"
            >
              Bekijk de stream!
            </a>
          </div>
        </div>

        <FlashingLight class="my-10" />
      </div>

      <TwitchLoginWall
        v-if="loginWall"
        :error="loginError"
      />
      <TwitchPayWall v-if="payWall" />
      <Notifications />
      <ItemModal
        v-if="showItemModal"
        :item="showItem"
        @close="showItemModal = false"
      />
    </div>
  </div>
</template>

<script>
import {Head} from '@inertiajs/vue2';
import FlashingLight from '../../Partials/FlashingLight.vue';
import Notifications from '../../Partials/Notifications.vue';
import TwitchLoginWall from '../../Partials/TwitchLoginWall.vue';
import TwitchPayWall from '../../Partials/TwitchPayWall.vue';
import ActionHandlers from '../../Mixins/ActionHandlers';
import ItemModal from '../../Modals/ItemModal.vue';
import TwitchAuction from '../../Partials/Products/TwitchAuction.vue';

export default {
  components: {TwitchAuction, ItemModal, Head, TwitchLoginWall, TwitchPayWall, Notifications, FlashingLight},

  mixins: [ActionHandlers],

  // removes the default layout and the stream
  layout: null,

  props: {
    seoTitle: {
      type: String,
      required: false,
      default: null,
    },

    seoDescription: {
      type: String,
      required: false,
      default: null,
    },

    seoKeywords: {
      type: String,
      required: false,
      default: null,
    },

    loginWall: {
      type: Boolean,
      required: true,
    },

    loginError: {
      type: String,
      required: false,
      default: null,
    },

    payWall: {
      type: Boolean,
      required: true,
    },

    auction: {
      type: Object,
      required: false,
      default: null,
    },

    streamUrl: {
      type: String,
      required: false,
      default: null,
    },
  },

  mounted () {
    this.$echo.channel('twitch')
      .listen('TwitchAuctionsUpdated', this.reload);

    if (!this.auction) {
      this.$eventHub.$emit('flashing-light', 'caution');
    }
  },

  destroyed () {
    this.$echo.leaveChannel('twitch');
  },

  methods: {
    auctionAlmostEnding() {
      this.$eventHub.$emit('flashing-light', 'default');
    },

    auctionIsEnding() {
      this.$eventHub.$emit('flashing-light', 'default_1');
    },

    auctionHasWon() {
      this.$eventHub.$emit('flashing-light', 'spotlight');

      setTimeout(() => this.reload(), 2000);
    },

    auctionEnded() {
      this.$eventHub.$emit('flashing-light', 'caution');

      setTimeout(() => this.reload(), 2000);
    },

    reload() {
      this.$inertia.get(this.route('frontend.twitch.index'));
    },

    open() {
      this.showItemModal = true;
      this.showItem = this.auction;
    },
  },
};
</script>
